import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBezwaarMakenHuurverhoging = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#6FBC85"
      d="M22.6 26.1c-.95.56-2.01.86-3.11.86-2.87 0-5.39-2.05-6.32-4.99h6.8v-4.99h-6.8c.93-2.94 3.45-4.99 6.32-4.99 1.74 0 3.37.74 4.63 2.08l3.64-3.41c-2.12-2.26-5.04-3.65-8.27-3.65-5.66 0-10.37 4.29-11.46 9.98H5v4.99h3.03c1.08 5.69 5.8 9.98 11.46 9.98 2.23 0 4.3-.68 6.07-1.83l-2.96-4.02z"
    />
    <path
      fill="#00A75D"
      fillRule="evenodd"
      d="M26 25h-3l6 8 6-8h-3v-9h-6z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBezwaarMakenHuurverhoging);

export default ForwardRef;
